import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/iconBG.png'


const _withScopeId = n => (_pushScopeId("data-v-453fd27e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sidebar__header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "logo",
  src: _imports_0,
  class: "sidebar__logo"
}, null, -1))
const _hoisted_3 = {
  key: 0,
  class: "sidebar__name"
}
const _hoisted_4 = { class: "sidebar__menu" }
const _hoisted_5 = ["href", "title", "onClick"]
const _hoisted_6 = {
  key: 0,
  class: "sidebar__itemLabel"
}
const _hoisted_7 = {
  key: 1,
  class: "sidebar__spacer"
}
const _hoisted_8 = ["title"]
const _hoisted_9 = {
  key: 0,
  class: "sidebar__itemLabel"
}
const _hoisted_10 = { class: "sidebar__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Badge = _resolveComponent("Badge")!
  const _component_Menu = _resolveComponent("Menu")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['sidebar', { 'sidebar--collapsed': $props.collapsed }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, {
        to: "/home",
        class: "sidebar__brand",
        onClick: $setup.emitNavigate
      }, {
        default: _withCtx(() => [
          _hoisted_2,
          (!$props.collapsed)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Quản lý tài sản"))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["onClick"]),
      ($setup.showCollapse)
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 0,
            class: "p-button-text sidebar__collapse",
            icon: 
          $props.collapsed ? 'pi pi-angle-double-right' : 'pi pi-angle-double-left'
        ,
            "aria-label": "Thu gọn",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggleCollapse')))
          }, null, 8, ["icon"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_Menu, {
        model: $setup.appMenus,
        class: "sidebar__menuCmp"
      }, {
        item: _withCtx(({ item, props }) => [
          (item.to)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: item.to,
                custom: ""
              }, {
                default: _withCtx(({ href, navigate, isActive }) => [
                  _createElementVNode("a", _mergeProps({ href: href }, props.action, {
                    class: [
                'sidebar__item',
                {
                  'sidebar__item--active': isActive,
                  'is-collapsed': $props.collapsed,
                },
              ],
                    title: $props.collapsed ? item.label : undefined,
                    onClick: 
                (e) => {
                  navigate(e);
                  $setup.emitNavigate();
                }
              
                  }), [
                    _createElementVNode("span", {
                      class: _normalizeClass([item.icon, 'sidebar__itemIcon'])
                    }, null, 2),
                    (!$props.collapsed)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(item.label), 1))
                      : _createCommentVNode("", true),
                    (!$props.collapsed)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_7))
                      : _createCommentVNode("", true),
                    (!$props.collapsed && item.badge)
                      ? (_openBlock(), _createBlock(_component_Badge, {
                          key: 2,
                          class: "ml-auto",
                          value: item.badge,
                          severity: "danger"
                        }, null, 8, ["value"]))
                      : _createCommentVNode("", true)
                  ], 16, _hoisted_5)
                ]),
                _: 2
              }, 1032, ["to"]))
            : (_openBlock(), _createElementBlock("a", _mergeProps({ key: 1 }, props.action, {
                class: ['sidebar__item', { 'is-collapsed': $props.collapsed }],
                title: $props.collapsed ? item.label : undefined,
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.emitNavigate && $setup.emitNavigate(...args)))
              }), [
                _createElementVNode("span", {
                  class: _normalizeClass([item.icon, 'sidebar__itemIcon'])
                }, null, 2),
                (!$props.collapsed)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(item.label), 1))
                  : _createCommentVNode("", true)
              ], 16, _hoisted_8))
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _createElementVNode("div", _hoisted_10, [
      (!$props.isLoggedIn)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: { name: 'login' },
            onClick: $setup.emitNavigate
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Button, {
                label: $props.collapsed ? '' : 'Đăng nhập',
                icon: "pi pi-sign-in",
                iconPos: "right"
              }, null, 8, ["label"])
            ]),
            _: 1
          }, 8, ["onClick"]))
        : (_openBlock(), _createBlock(_component_Button, {
            key: 1,
            label: $props.collapsed ? '' : 'Đăng xuất',
            onClick: $setup.logout,
            icon: "pi pi-sign-out",
            iconPos: "right",
            class: "p-button-secondary"
          }, null, 8, ["label", "onClick"]))
    ])
  ], 2))
}